export enum ProductoStockEstado {
  Vencido,
  Agotado,
  EnStock,
}

export const ProductoStockEstadoLabels: {
  [key in ProductoStockEstado]: string;
} = {
  [ProductoStockEstado.Vencido]: 'Vencido',
  [ProductoStockEstado.Agotado]: 'Agotado',
  [ProductoStockEstado.EnStock]: 'EnStock',
};

export const getProductoStockEstado = () => {
  return Object.values(ProductoStockEstado)
    .filter((value) => typeof value === 'number')
    .map((id) => ({
      id,
      text: ProductoStockEstadoLabels[id as ProductoStockEstado],
    }));
};
